import { useMemo } from 'react';
import { Permission } from '@weave/schema-gen-ts/dist/shared/waccess/acls.pb';
import { hasSchemaACL } from '@frontend/auth-helpers';
import { useAppScopeStore } from '@frontend/scope';

export const useGetHasInsuranceVerificationAccess = (locationId: string) => {
  const { selectedLocationIds } = useAppScopeStore();

  const isMultiLocation = selectedLocationIds.length > 1;

  const getHasInsuranceVerificationAccess = (locationId: string) =>
    hasSchemaACL(locationId, [Permission.INSURANCE_VERIFICATION_READ, Permission.INSURANCE_VERIFICATION_WRITE]);

  const { allChildLocationIdDoNotHaveAccess, locationIdsWithAccess } = useMemo(() => {
    if (!isMultiLocation) {
      return { allChildLocationIdDoNotHaveAccess: false, locationIdsWithAccess: [] };
    }
    const locationIdsWithAccess = selectedLocationIds.filter((locationId) => {
      return getHasInsuranceVerificationAccess(locationId);
    });
    const allChildLocationIdDoNotHaveAccess = locationIdsWithAccess.length === 0;

    return { allChildLocationIdDoNotHaveAccess, locationIdsWithAccess };
  }, [isMultiLocation, selectedLocationIds]);

  const hasWeaveInsuranceVerificationFullAccess = getHasInsuranceVerificationAccess(locationId);

  return {
    hasWeaveInsuranceVerificationFullAccess,
    isMultiLocation,
    allChildLocationIdDoNotHaveAccess,
    locationIdsWithAccess,
  };
};
